import { useEffect, useRef, useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import generateRender from 'shared/utils/generateRender';

const tooltipIconOffsetDivider = generateRender({
  default: isTablet ? 2.8 : isMobile ? 1.5 : 2.3,
  hri: isTablet ? 2.3 : isMobile ? 2 : 2,
  ti: isTablet ? 3 : isMobile ? 1.5 : 2.2,
});

function useIconTooltipPositionCalc({ imageOnly, tooltipWidth }) {
  const iconImageRef = useRef(null);
  const resizeObserverRef = useRef(null);
  const [iconTooltipPosition, setTooltipPosition] = useState({ left: 0 });

  useEffect(() => {
    if (!imageOnly) {
      resizeObserverRef.current?.disconnect();
      resizeObserverRef.current = null;
      return;
    }

    requestAnimationFrame(() => {
      const element = iconImageRef.current;
      if (!element) return;

      const updatePosition = () => {
        const rect = element.getBoundingClientRect();
        const relativeLeft = -(tooltipWidth / 2) + rect.width / tooltipIconOffsetDivider;
        setTooltipPosition({ left: relativeLeft });
      };

      updatePosition();

      const resizeObserver = new ResizeObserver(updatePosition);
      resizeObserver.observe(element);
      resizeObserverRef.current = resizeObserver;

      return () => {
        resizeObserver.disconnect();
      };
    });
  }, [imageOnly]);

  return {
    iconImageRef,
    iconTooltipPosition,
  };
}

export default useIconTooltipPositionCalc;

